"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeArrays = function (a, b) {
    var normalizedA = [];
    var normalizedB = [];
    if (a) {
        normalizedA = Array.isArray(a) ? a : [a];
    }
    if (b) {
        normalizedB = Array.isArray(b) ? b : [b];
    }
    return __spreadArrays(normalizedA, normalizedB);
};
//# sourceMappingURL=merge-arrays.js.map